import { reactive } from 'vue';

// Per-phone settings. Matt, 2026-09-22: "a setting you could turn on where
// when you made a choice, a pop-up confirmation dialog would show up, and
// it would confirm exactly what it was going to cost you and what you were
// going to gain... a checkbox on the confirm dialogue that says don't show
// me this one again." On for a new phone - "at first it might be really
// helpful" - and off in the menu once it is annoying.
const CONFIRM_KEY = 'commonwealth:confirm';
const SKIP_KEY = 'commonwealth:confirm-skip';
// Matt, 2026-09-28 (pacing): "we should make sure that everyone understands
// what happens after their actions" - an outcome card after every act, on
// the actor's own phone. On for a new phone; off in the menu.
const OUTCOME_KEY = 'commonwealth:outcome';

const read = (key, fallback) => {
  try { const v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); } catch { return fallback; }
};
const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage off */ } };

export const settings = reactive({
  confirm: read(CONFIRM_KEY, true),
  // Actions this phone has said "don't ask again" to, as "role:actionId".
  skip: read(SKIP_KEY, []),
  outcome: read(OUTCOME_KEY, true),
});

export const setOutcome = (on) => { settings.outcome = Boolean(on); write(OUTCOME_KEY, settings.outcome); };

export const setConfirm = (on) => { settings.confirm = Boolean(on); write(CONFIRM_KEY, settings.confirm); };
export const skipConfirm = (key) => {
  if (!settings.skip.includes(key)) settings.skip = [...settings.skip, key];
  write(SKIP_KEY, settings.skip);
};
export const askAgainForAll = () => { settings.skip = []; write(SKIP_KEY, []); };
export const confirmWanted = (key) => settings.confirm && !settings.skip.includes(key);
